// extracted by mini-css-extract-plugin
export default {"modal":"p_aC5m","modal__overlay":"GZmqfP"};